<template>
  <div
    class="app-main-inner app-main-page doc-category"
  >
    <div class="app-main-inner-row">
      <div class="triggers">
        <template v-if="[0, 2, 5].includes(optStatus)">
          <el-button type="primary" @click="toAdd">{{ addBtnText }}</el-button>
          <el-button type="primary" :disabled="optStatus === 0" @click="toEdit">{{ $t('SystemMaintenance.Edit') }}</el-button>
          <el-button type="danger" :disabled="optStatus === 0" @click="toDelete">{{ $t('SystemMaintenance.Delete') }}</el-button>
          <el-button v-if="optStatus === 0 && $store.getters.isAdmin" :disabled="Object.keys(currentData).length === 0" type="primary" @click="setDefaultType">{{ $t('CargoMsg.SetDefaultType') }}</el-button>
          <el-button v-if="optStatus === 5" type="primary" @click="setFileSyncRule">{{ $t('SystemMaintenance.SetFileSyncRule') }}</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="save">{{ $t('SystemMaintenance.Save') }}</el-button>
          <el-button type="primary" @click="cancel">{{ $t('SystemMaintenance.Cancel') }}</el-button>
        </template>
      </div>
    </div>
    <el-form v-if="optStatus === 0" label-position="left" label-width="85px" style="margin: 15px 0 0 15px">
      <el-form-item :label="$t('CargoMsg.DefaultFileType')" style="width: 215px;">
        <el-input :value="currentData.defaultDocumentChineseName" :disabled="true" />
      </el-form-item>
    </el-form>
    <div v-if="optStatus !== 0" class="app-main-inner-row">
      <el-card style="width: 100%;">
        <div slot="header">
          <span>{{ formHeadText }}</span>
        </div>
        <el-form
          v-if="[1, 2, 3].includes(optStatus)"
          v-model="docCategoryForm"
          :disabled="optStatus === 2"
          label-position="left"
          label-width="90px"
          style="width:100%;"
        >
          <el-form-item :label="$t('SystemMaintenance.SerialNumber')">
            <el-input-number
              v-model="docCategoryForm.level"
              :min="0"
              controls-position="right"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Code')">
            <el-input
              v-model="docCategoryForm.code"
              v-uppercase
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.ChineseName')">
            <el-input
              v-model="docCategoryForm.name"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.EnglishName')">
            <el-input
              v-model="docCategoryForm.localName"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Remark')">
            <el-input
              v-model="docCategoryForm.remarks"
              type="textarea"
              :rows="3"
            />
          </el-form-item>
        </el-form>
        <el-form
          v-if="[4, 5, 6].includes(optStatus)"
          v-model="docTypeForm"
          :disabled="optStatus === 5"
          label-position="left"
          label-width="90px"
          style="width:100%;"
        >
          <el-form-item :label="$t('SystemMaintenance.SerialNumber')">
            <el-input-number
              v-model="docTypeForm.level"
              :min="0"
              controls-position="right"
            />
            <el-checkbox :value="docTypeForm.defaultDocumentType" :disabled="true" :label="$t('CargoMsg.DefaultType')" style="margin-left: 10px;" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Code')">
            <el-input
              v-model="docTypeForm.code"
              v-uppercase
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.ChineseName')">
            <el-input
              v-model="docTypeForm.name"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.EnglishName')">
            <el-input
              v-model="docTypeForm.localName"
            />
          </el-form-item>
          <el-form-item v-if="toExoSystemOC" :label="$t('SystemMaintenance.ExternalFileType')">
            <el-select v-model="docTypeForm.externalFileType">
              <el-option v-for="item in FileType.EXTERNAL_FILE_TYPES" :key="item.code" :label="item.chineseName" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="!toExoSystemOC" :label="$t('SystemMaintenance.ExternalFileType')">
            <el-input v-if="optStatus === 0" v-model="externalFileTypeList" :disabled="true" />
            <el-input v-else v-model="externalFileTypeList" readonly @focus="showFileTypeDialog" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.NecessaryScenario')">
            <el-input
              v-model="docTypeForm.essentialScene"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.OriginalScenario')">
            <el-input
              v-model="docTypeForm.originalScene"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Remark')">
            <el-input
              v-model="docTypeForm.remarks"
              type="textarea"
              :rows="3"
            />
          </el-form-item>
          <div style="width: calc(100% + 40px);margin-left: -20px;padding: 10px 0 5px 20px;border: 1px solid #DCDFE6;border-radius: 2px;margin-bottom: 10px;">
            <el-form-item :label="$t('SystemMaintenance.TypePermission')" />
            <el-form-item>
              <span slot="label" style="padding-left: 10px">{{ $t('SystemMaintenance.SpecifyRole') }}</span>
              <el-checkbox v-model="docTypeForm.other" :label="$t('SystemMaintenance.AllPositions')" />
              <el-checkbox v-model="docTypeForm.sales" :label="$t('SystemMaintenance.Sales')" />
              <el-checkbox v-model="docTypeForm.op" :label="$t('SystemMaintenance.Operation')" />
              <el-checkbox v-model="docTypeForm.csr" :label="$t('SystemMaintenance.CustomerService')" />
              <el-checkbox v-model="docTypeForm.dc" :label="$t('SystemMaintenance.Documentation')" />
              <el-checkbox v-model="docTypeForm.cargoSales" :label="$t('SeaExport.SalesOfGoods')" />
              <el-checkbox v-model="docTypeForm.overseaOp" :label="$t('SystemMaintenance.OverseasCustomerService')" />
              <el-checkbox v-model="docTypeForm.planner" :label="$t('SystemMaintenance.ShippingLineManager')" />
              <el-checkbox v-model="docTypeForm.userDefinedRoleId1" :label="$t('CargoMsg.Cargo_userDefinedRole1')" />
              <el-checkbox v-model="docTypeForm.userDefinedRoleId2" :label="$t('CargoMsg.Cargo_userDefinedRole2')" />
              <el-checkbox v-model="docTypeForm.customer" :label="$t('SystemMaintenance.Consignor')" />
              <el-checkbox v-model="docTypeForm.shipper" :label="$t('SystemMaintenance.Shipper')" />
              <el-checkbox v-model="docTypeForm.consignee" :label="$t('SystemMaintenance.Consignee')" />
              <el-checkbox v-model="docTypeForm.destinationAgent" :label="$t('SystemMaintenance.OverseasAgent')" />
              <el-checkbox v-model="docTypeForm.bookingAgent" :label="$t('SystemMaintenance.BookingAgent')" />
              <el-checkbox v-model="docTypeForm.shared" :label="$t('SystemMaintenance.ExternalAccess')" />
              <el-checkbox v-model="docTypeForm.b2bCustomer" :label="$t('SystemMaintenance.B2BCustomer')" />
              <el-checkbox v-model="docTypeForm.b2bDesignationAgent" :label="$t('SystemMaintenance.B2BDesignatedCargoAgent')" />
              <el-checkbox v-model="docTypeForm.b2bDestinationAgent" :label="$t('SystemMaintenance.B2BDestinationPortAgent')" />
              <el-checkbox v-model="docTypeForm.b2bConsignee" :label="$t('SystemMaintenance.B2BConsignee')" />
            </el-form-item>
            <el-form-item>
              <span slot="label" style="padding-left: 10px">{{ $t('SystemMaintenance.DesignatedPersonnel') }}</span>
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_User"
                :fields="['chineseName']"
                :filter-tag-names="['chineseName']"
                tag-name="chineseName"
                :disabled="optStatus === 5"
                filterable
                multiple
                :default-multiple-value="toNumArray(docTypeForm.designatePersons)"
                options-width="230px"
                :placeholder="$t('Message.PleaseSelect')"
                style="width:205px;"
                @parentCallBack="p=>{docTypeForm.designatePersons=toTxt(p.value)}"
              />
            </el-form-item>
            <el-form-item label-width="0">
              <span style="padding-left: 10px">{{ $t('SystemMaintenance.CheckPrivilegePersonLabel') }}</span>
              <el-radio-group v-model="docTypeForm.checkPrivilegePerson" style="margin-left: 30px;">
                <el-radio :label="true">{{ $t('SystemMaintenance.Yes') }}</el-radio>
                <el-radio :label="false">{{ $t('SystemMaintenance.No') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <!-- <el-form-item>
            <span slot="label">{{ $t('SystemMaintenance.DefaultSync') }}
              <el-popover placement="bottom" width="400" trigger="hover">
                <div class="pop-content">{{ $t('SystemMaintenance.UsedFileAutomaticallySynchronizesBusiness') }}</div>
                <svg-icon slot="reference" icon-class="question" style="font-size: 14px;margin-top: -3px;" />
              </el-popover>
            </span>
            <el-radio-group v-model="docTypeForm.synchronization">
              <el-radio :label="1">{{ $t('SystemMaintenance.Yes') }}</el-radio>
              <el-radio :label="0">{{ $t('SystemMaintenance.No') }}</el-radio>
            </el-radio-group>
          </el-form-item> -->
        </el-form>
      </el-card>
      <el-card v-if="[4, 5, 6].includes(optStatus) && showTemplateRuleConfig" style="width: 60%; margin-left: 60px;">
        <div slot="header">
          <span>{{ $t('SystemMaintenance.CustomTemplateName') }}</span>
        </div>
        <el-form
          v-if="[4, 5, 6].includes(optStatus)"
          v-model="docTypeForm"
          :disabled="optStatus === 5"
          label-position="left"
          label-width="90px"
          style="width:100%;"
        >
          <el-form-item :label="$t('SystemMaintenance.TemplateOutputName')">
            <el-select v-model="docTypeForm.templateRuleZero" class="template-rule-name-select">
              <el-option
                v-for="item in templateRuleNameOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
            <el-select v-model="docTypeForm.templateRuleOne" class="template-rule-name-select">
              <el-option
                v-for="item in templateRuleNameOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
            <el-select v-model="docTypeForm.templateRuleTwo" class="template-rule-name-select">
              <el-option
                v-for="item in templateRuleNameOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
            <el-select v-model="docTypeForm.templateRuleThree" class="template-rule-name-select">
              <el-option
                v-for="item in templateRuleNameOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
            <el-select v-model="docTypeForm.templateRuleFour" class="template-rule-name-select">
              <el-option
                v-for="item in templateRuleNameOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Delimiter')">
            <el-radio-group v-model="docTypeForm.separators">
              <el-radio :label="0">{{ $t('SystemMaintenance.Underscore_') }}</el-radio>
              <el-radio :label="1">{{ $t('SystemMaintenance.Hyphen') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Example')">
            <span style="font-size: 12px; font-weight: normal;">{{ templateRuleNameExample }}</span>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.AutomPrintDefaultFileType')" label-width="auto">
            <el-select v-model="docTypeForm.autoPrintDefaultFileType" clearable style="width: auto">
              <el-option label="PDF" value="ExportPDF" />
              <el-option label="WORD" value="ExportWORD" />
              <el-option label="EXCEL" value="ExportXLS" />
              <el-option label="PPT" value="ExportPPT" />
            </el-select>
          </el-form-item>
        </el-form>
        <el-alert :title="$t('SystemMaintenance.NoteTemplateNameAccordingNeeds')" type="info" center show-icon :closable="false" style="margin-top: 35px;" />
      </el-card>
    </div>
    <!-- 文档类别弹窗 -->
    <el-dialog
      ref="docTypeTreeDialog"
      v-el-drag-dialog
      :visible.sync="docTypeTree.visible"
      :title="$t('CargoMsg.SetDefaultType')"
      width="400px"
      :close-on-click-modal="false"
      class="app-main-inner"
      append-to-body
    >
      <div class="app-main-inner-row">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params.sync="docTypeTree.girdParams"
          :grid-options="docTypeTree.gridOptions"
          :row-data="docTypeTree.rowData"
          style="width:350px;height:300px;padding-left:2px"
          @gridReady="params=>{docTypeTree.gridApi=params.api}"
        />
      </div>
      <span slot="footer" style="padding-right:30px">
        <el-button type="primary" @click="saveDefaultType">{{ $t('common.btn.ok') }}</el-button>
        <el-button @click="docTypeTree.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 文件类型选择对话框 -->
    <assign-file-type-editor
      v-if="fileTypeEditor.visible"
      :visible.sync="fileTypeEditor.visible"
      :file-id="fileTypeEditor.fileId"
      :data-list="fileTypeEditor.dataList"
      :file-category="fileTypeEditor.fileCategory"
      @saveFileType="onSaveFileType"
    />
    <!-- 设置文件同步规则弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="fileSyncRuleDialog.visible"
      :title="$t('SystemMaintenance.SetFileSyncRule')"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="details-view">
        <div class="main-content">
          <el-form label-width="100px" label-position="right">
            <el-form-item>
              <line-label slot="label" class="title" :label="$t('SystemMaintenance.BusinessModel')" style="font-size: 12px;margin-bottom: 0;" />
              <el-checkbox v-model="fileSyncRuleDialog.form.isCrossTrustMode" :label="$t('SystemMaintenance.CrossDelegation')" @change="onCrossTrustModelChange" />
            </el-form-item>
            <el-form-item>
              <line-label slot="label" :label="$t('SystemMaintenance.SyncDirection')" />
              <el-checkbox v-model="fileSyncRuleDialog.form.isTrustToOperate" :disabled="!fileSyncRuleDialog.form.isCrossTrustMode" :label="$t('SystemMaintenance.PrincipalOperator')" />
              <el-checkbox v-model="fileSyncRuleDialog.form.isOperateToTrust" :disabled="!fileSyncRuleDialog.form.isCrossTrustMode" :label="$t('SystemMaintenance.OperatorClient')" />
            </el-form-item>
            <el-form-item>
              <line-label slot="label" :label="$t('SystemMaintenance.SyncMode')" />
              <el-radio-group v-model="fileSyncRuleDialog.form.trustSyncFileMode" :disabled="!fileSyncRuleDialog.form.isCrossTrustMode">
                <el-radio :label="1">{{ $t('SystemMaintenance.ManualSync') }}</el-radio>
                <el-radio :label="2">{{ $t('SystemMaintenance.AutoSync') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="fileSyncRuleDialog.form.trustSyncFileMode === 1">
              <line-label slot="label" :label="$t('CargoMsg.Cargo_Append') + $t('CargoMsg.Cargo_Status') + '：'" />
              <!--              <el-checkbox v-model="fileSyncRuleDialog.form.ctmSyncFileApprovedDoc" :disabled="!fileSyncRuleDialog.form.isCrossTrustMode" :label="$t('SystemMaintenance.SyncFileToApprovedDoc')" />-->
              <cargo-advance-select
                :disabled="!fileSyncRuleDialog.form.isCrossTrustMode"
                filterable
                :static-options="jobStates"
                :default-multiple-value="ctmSyncFileApprovedDocArray"
                :multiple="true"
                tag-name="chineseName"
                tag-value="code"
                style="width: 300px;"
                :custom-label="(item)=>`${item.chineseName}`"
                @parentCallBack="p=>{ctmSyncFileApprovedDocArray=p.code}"
              />
            </el-form-item>
            <el-divider />
            <el-form-item>
              <line-label slot="label" class="title" :label="$t('SystemMaintenance.BusinessModel')" style="font-size: 12px;margin-bottom: 0;" />
              <el-checkbox v-model="fileSyncRuleDialog.form.isExportToImportMode" :label="$t('SystemMaintenance.ExportToImport')" @change="onExportToImportModelChange" />
            </el-form-item>
            <el-form-item>
              <line-label slot="label" :label="$t('SystemMaintenance.SyncDirection')" />
              <el-checkbox v-model="fileSyncRuleDialog.form.isExportToImport" :disabled="!fileSyncRuleDialog.form.isExportToImportMode" :label="$t('SystemMaintenance.ExporterImporter')" />
              <el-checkbox v-model="fileSyncRuleDialog.form.isImportToExport" :disabled="!fileSyncRuleDialog.form.isExportToImportMode" :label="$t('SystemMaintenance.ImporterExporter')" />
            </el-form-item>
            <el-form-item>
              <line-label slot="label" :label="$t('SystemMaintenance.SyncMode')" />
              <el-radio-group v-model="fileSyncRuleDialog.form.exportImportSyncFileMode" :disabled="!fileSyncRuleDialog.form.isExportToImportMode">
                <el-radio :label="1">{{ $t('SystemMaintenance.ManualSync') }}</el-radio>
                <el-radio :label="2">{{ $t('SystemMaintenance.AutoSync') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="fileSyncRuleDialog.form.exportImportSyncFileMode === 1">
              <line-label slot="label" :label="$t('CargoMsg.Cargo_Append') + $t('CargoMsg.Cargo_Status') + '：'" />
              <!--              <el-checkbox v-model="fileSyncRuleDialog.form.etiSyncFileApprovedDoc" :disabled="!fileSyncRuleDialog.form.isExportToImportMode" :label="$t('SystemMaintenance.SyncFileToApprovedDoc')" />-->
              <cargo-advance-select
                :disabled="!fileSyncRuleDialog.form.isExportToImportMode"
                filterable
                :static-options="jobStates"
                :default-multiple-value="etiSyncFileApprovedDocArray"
                :multiple="true"
                tag-name="chineseName"
                tag-value="code"
                style="width: 300px;"
                :custom-label="(item)=>`${item.chineseName}`"
                @parentCallBack="p=>{etiSyncFileApprovedDocArray=p.code}"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="saveFileSyncRule">{{ $t('SystemMaintenance.Save') }}</el-button>
        <el-button @click="fileSyncRuleDialog.visible=false">{{ $t('SystemMaintenance.Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  docCategoryDetail,
  addDocCategory,
  updateDocCategory,
  deleteDocCategory,
  getDocCategoryNextLevel,
  docCategoryCodeExists
} from '@/api/sysManage/baseConfig/docCategory'
import {
  getDocumentType,
  addDocType,
  updateDocType,
  deleteDocType,
  getDocTypeNextLevel,
  docTypeCodeExists, checkDocType, setDefaultDocumentType
} from '@/api/documentType'
import { cacheName, cache } from '@/utils/cacheManager'
import { Assert } from '@/utils/validate'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import * as FileType from '@/class/cargo/model/parameters/FileType'
import * as ExternalFileType from '@/class/cargo/model/parameters/ExternalFileType'
import { DocumentCategory } from '@/class/model/sys/DocumentCategory'
import assignFileTypeEditor from '@/components/Cargo/Job/assignFileTypeEditor'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'

export default {
  name: 'DocCategory',
  components: {
    assignFileTypeEditor, cargoAdvanceSelect
  },
  props: {
    currentData: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      TYPE_NAMES,
      fullscreenLoading: null,
      /**
       * 操作状态
       * 父组件中传递进来的currentData中的type值0,1,2对应到optStatus分别为0，2，5
       * 0-btn[新增文件归类]&无表单显示
       * 1-btn[保存-取消]&新增文件归类表单
       * 2-btn[新增文件类型]&修改文件归类表单-不可编辑
       * 3-btn[保存-取消]&修改文件归类表单-可编辑
       * 4-btn[保存-取消]&新增文件类型表单
       * 5-btn[新增文件类型]&修改文件类型表单-不可编辑
       * 6-btn[保存-取消]&修改文件类型表单-可编辑
       */
      optStatus: 0,
      docCategoryUuid: '',
      templateRuleNameOptions: [
        {
          name: ' ',
          value: '0'
        },
        ...this.$constantI18n('templateRuleName')
      ],
      showTemplateRuleConfig: false,
      initDocCategoryForm: {
        level: '',
        code: '',
        name: '',
        localName: '',
        remarks: '',
        lob: '',
        fba: false
      },
      initDocTypeForm: {
        level: 1,
        code: '',
        name: '',
        localName: '',
        essentialScene: '',
        originalScene: '',
        remarks: '',
        sales: false,
        op: false,
        other: false,
        customer: false,
        shipper: false,
        consignee: false,
        destinationAgent: false,
        bookingAgent: false,
        shared: false,
        b2bCustomer: false,
        b2bDesignationAgent: false,
        b2bDestinationAgent: false,
        b2bConsignee: false,
        userDefinedRoleId1: false,
        userDefinedRoleId2: false,
        lob: '',
        documentCategoryUuid: '',
        separators: 0,
        templateRuleZero: '0', // 默认为空
        templateRuleOne: '0',
        templateRuleTwo: '0',
        templateRuleThree: '0',
        templateRuleFour: '0',
        externalFileType: 0,
        synchronization: 0,
        designatePersons: '',
        checkPrivilegePerson: false,
        isCrossTrustMode: false,
        isTrustToOperate: false,
        isOperateToTrust: false,
        trustSyncFileMode: 0,
        isExportToImportMode: false,
        isExportToImport: false,
        isImportToExport: false,
        exportImportSyncFileMode: 0,
        ctmSyncFileApprovedDoc: '',
        etiSyncFileApprovedDoc: '',
        csr: false,
        dc: false,
        cargoSales: false,
        overseaOp: false,
        planner: false,
        autoPrintDefaultFileType: '26' // 自动打印默认文件类型
      },
      ctmSyncFileApprovedDocArray: [],
      etiSyncFileApprovedDocArray: [],
      jobStates: [SeaExportConstants.STATE_COMMITED, SeaExportConstants.STATE_VERIFIED, SeaExportConstants.STATE_PRE_COMMIT],
      docCategoryForm: {},
      docTypeForm: {},
      docCategoryData: {},
      docTypeData: {},
      FileType,
      docTypeTree: {
        visible: false,
        girdParams: {},
        gridOptions: {
          rowSelection: 'single',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SeaExport.DocumentType'),
            width: 320,
            suppressMenu: true,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 2) {
                  const iconName = params.data.checked
                    ? 'checkbox-checked'
                    : 'checkbox-notChecked'
                  return `<svg class="svg-icon" aria-hidden="true" style="height:1.2em;width:1.2em;vertical-align:text-bottom;">
                            <use xlink:href="#icon-${iconName}"></use>
                          </svg>
                          &nbsp;${params.data.chineseName}`
                }
                return params.data.chineseName
              }
            },
            onCellClicked: params => {
              if (params.data.type === 2) {
                const checked = !params.data.checked
                // 重置所有选中
                if (checked) {
                  this.docTypeTree.rowData.forEach(item => {
                    item.checked = false
                  })
                }
                params.data.checked = checked
                params.api.refreshCells({ force: true })
              }
            }
          },
          columnDefs: [],
          onRowDataChanged: event => {
            event.api.clearFocusedCell()
            if (this.docTypeTree.rowData.length > 0) {
              setTimeout(() => {
                const nodes = event.api.rowModel.rootNode.allLeafChildren
                const expandedNode = nodes.find(p => p.data.type === 2 && p.data.checked)
                if (expandedNode) {
                  expandedNode.parent.expanded = true
                  event.api.onGroupExpandedOrCollapsed()
                  event.api.setFocusedCell(expandedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
                }
              }, 100)
            }
          },
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      fba: false, // 是否FBA
      toExoSystemOC: false, // 是否橙联
      externalFileTypeList: '',
      fileTypeEditor: {
        visible: false,
        fileId: '',
        fileCategory: '',
        dataList: []
      },
      fileSyncRuleDialog: {
        visible: false,
        form: {}
      }
    }
  },
  computed: {
    addBtnText() {
      if (this.optStatus === 0) {
        return this.$t('SystemMaintenance.CreateFileClassification')
      }
      if ([2, 5].includes(this.optStatus)) {
        return this.$t('SystemMaintenance.CreateFileType')
      }
      return ''
    },
    formHeadText() {
      const statusText = [1, 4].includes(this.optStatus) ? this.$t('SystemMaintenance.Create') : this.$t('SystemMaintenance.Modify')
      return statusText + ([1, 2, 3].includes(this.optStatus) ? this.$t('SystemMaintenance.FileClassification') : this.$t('SystemMaintenance.FileType'))
    },
    templateRuleNameExample() {
      let templateRule0, templateRule1, templateRule2, templateRule3, templateRule4
      const formRule0 = this.docTypeForm.templateRuleZero
      const formRule1 = this.docTypeForm.templateRuleOne
      const formRule2 = this.docTypeForm.templateRuleTwo
      const formRule3 = this.docTypeForm.templateRuleThree
      const formRule4 = this.docTypeForm.templateRuleFour
      this.templateRuleNameOptions.forEach(item => {
        templateRule0 = (!templateRule0 && (item.value === formRule0)) ? item.name : templateRule0
        templateRule1 = (!templateRule1 && (item.value === formRule1)) ? item.name : templateRule1
        templateRule2 = (!templateRule2 && (item.value === formRule2)) ? item.name : templateRule2
        templateRule3 = (!templateRule3 && (item.value === formRule3)) ? item.name : templateRule3
        templateRule4 = (!templateRule4 && (item.value === formRule4)) ? item.name : templateRule4
      })
      return [templateRule0, templateRule1, templateRule2, templateRule3, templateRule4].filter(item => item && item.trim()).join(this.docTypeForm.separators === 0 ? '_' : '-')
    }
  },
  watch: {
    currentData(newV, oldV) {
      const self = this
      this.initOptStatus()
      this.docCategoryUuid = newV.path.split(',')[1]
      if ([2, 3].includes(this.optStatus)) {
        self.fullscreenLoading = getLoading()
        docCategoryDetail(newV.uuid).then((result) => {
          self.docCategoryForm = { ...result.data }
          self.docCategoryData = { ...result.data }
        }).finally(() => {
          self.fullscreenLoading.close()
        })
      }
      if ([5, 6].includes(this.optStatus)) {
        self.fullscreenLoading = getLoading()
        getDocumentType(newV.uuid).then((result) => {
          self.docTypeForm = { ...result.data }
          this.showLabel(self.docTypeForm.externalFileTypeList)
          if (!self.docTypeForm.synchronization) {
            self.docTypeForm.synchronization = 0
          }
          self.docTypeData = { ...result.data }
        }).finally(() => {
          self.fullscreenLoading.close()
        })
      }
      this.fba = newV && newV.lob && (newV.lob.startsWith('FBA_'))
    },
    optStatus(newV, oldV) {
      if ([0, 2, 5].includes(newV)) {
        this.$emit('maskTree', false)
      } else {
        this.$emit('maskTree', true)
      }
    }
  },
  mounted() {
    this.templateNameRuleButton()
  },
  methods: {
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
      this.configMap = cache.config
      this.toExoSystemOC = Number(cache.config.get('ToExoSystem')) === 2
    },
    async templateNameRuleButton() {
      await this.preloadBasicData()
      // 是否启用模板自定义功能
      this.showTemplateRuleConfig = Number(this.configMap.get('templateNameRuleButton')) === 1
    },
    initOptStatus() {
      const currentDataType = this.currentData.type
      this.optStatus = currentDataType === 0 ? 0 : (currentDataType === 1 ? 2 : (currentDataType === 2 ? 5 : 0))
    },
    toAdd() {
      const self = this
      if (this.optStatus === 0) {
        if (this.initDocCategoryForm.lob && this.initDocCategoryForm.lob.startsWith('FBA_')) {
          this.initDocCategoryForm.lob = this.initDocCategoryForm.lob.split('FBA_')[1]
        }
        this.docCategoryForm = { ...this.initDocCategoryForm }
        this.optStatus = 1
        this.fullscreenLoading = getLoading()
        if (this.currentData.lob && this.currentData.lob.startsWith('FBA_')) {
          this.currentData.lob = this.currentData.lob.split('FBA_')[1]
        }
        getDocCategoryNextLevel(this.currentData.lob).then((result) => {
          self.docCategoryForm.level = result.data
        }).finally(() => {
          self.fullscreenLoading.close()
        })
      }
      if ([2, 5].includes(this.optStatus)) {
        if (this.initDocTypeForm.lob && this.initDocTypeForm.lob.startsWith('FBA_')) {
          this.initDocTypeForm.lob = this.initDocTypeForm.lob.split('FBA_')[1]
        }
        this.docTypeForm = { ...this.initDocTypeForm }
        this.optStatus = 4
        this.fullscreenLoading = getLoading()
        getDocTypeNextLevel(this.docCategoryUuid).then((result) => {
          self.docTypeForm.level = result.data <= 0 ? 1 : result.data
        }).finally(() => {
          self.fullscreenLoading.close()
        })
      }
    },
    toEdit() {
      this.optStatus = this.optStatus === 2 ? 3 : (this.optStatus === 5 ? 6 : null)
    },
    toDelete() {
      if (this.currentData) {
        const self = this
        this.$confirm(this.$t('CargoMsg.Cargo_ConfirmDeleteCategoryAndType'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          const originType = Number(self.currentData.type)
          const originUuid = self.currentData.uuid
          if (originType === 1) {
            self.deleteDocCategory(originUuid)
          } else if (originType === 2) {
            self.deleteDocType(originUuid)
          }
        }).catch(() => {
          this.$message.info(this.$t('common.tips.cancelDelete'))
        })
      }
    },
    async save() {
      if (this.docCategoryForm.lob && this.docCategoryForm.lob.startsWith('FBA_')) {
        this.docCategoryForm.lob = this.docCategoryForm.lob.split('FBA_')[1]
      }
      if (this.docTypeForm.lob && this.docTypeForm.lob.startsWith('FBA_')) {
        this.docTypeForm.lob = this.docTypeForm.lob.split('FBA_')[1]
      }
      await this.checkForm()
      // 触发数据显示(待处理,父级组件刷新数据后重新选取自动触发状态变更), 此处暂统一恢复到原状态
      switch (this.optStatus) {
        case 1: this.addDocCategory(); break
        case 3: this.updateDocCategory(); break
        case 4: this.addDocType(); break
        case 6: this.updateDocType(); break
        default : this.$message.warning('当前操作状态异常！')
      }
      DocumentCategory.clearDocCategoryTypeTreeByLob()
    },
    cancel() {
      if ([1, 3].includes(this.optStatus)) {
        this.docCategoryForm = { ...this.docCategoryData }
      }
      if ([4, 6].includes(this.optStatus)) {
        this.docTypeForm = { ...this.docTypeData }
      }
      this.initOptStatus()
    },
    async checkForm() { // 表单校验过程中为请求表单数据添加必要的数据项lob & documentCategoryUuid
      let formData = {}
      let codeExistsCheck = null
      if ([1, 3].includes(this.optStatus)) {
        formData = this.docCategoryForm
        codeExistsCheck = docCategoryCodeExists
      }
      if ([4, 6].includes(this.optStatus)) {
        formData = this.docTypeForm
        formData.documentCategoryUuid = this.docCategoryUuid
        codeExistsCheck = docTypeCodeExists
        // const hasTemplateRule = [formData.templateRuleZero, formData.templateRuleOne, formData.templateRuleTwo, formData.templateRuleThree, formData.templateRuleFour].findIndex(item => item && item !== '0') > -1
        // await Assert.isTrue(hasTemplateRule, this.$t('SystemMaintenance.CustomTemplateMustSelect'))
      }
      const { code, name, uuid } = { ...formData }
      let { lob } = { ...formData }
      lob = lob || (this.currentData.path ? this.currentData.path.split(',')[0] : lob)
      if (lob && lob.startsWith('FBA_')) {
        lob = lob.split('FBA_')[1]
      }
      formData.lob = lob
      await Assert.isNotBlank(code, this.$t('SystemMaintenance.PleaseEnterTheCode'))
      await Assert.isNotBlank(name, this.$t('SystemMaintenance.PleaseSelectChineseName'))
      await Assert.isNotBlank(codeExistsCheck, this.$t('SystemMaintenance.CurrentOperatingStatusAbnormal'))
      this.fullscreenLoading = getLoading()
      await codeExistsCheck(code, uuid, lob).then(async result => {
        await Assert.isFalsy(result.data, this.$t('SystemMaintenance.CondAlreadyExists'))
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    addDocCategory() {
      const self = this
      this.fullscreenLoading = getLoading()
      this.docCategoryForm.fba = this.fba
      addDocCategory(this.docCategoryForm).then((result) => {
        self.$message.success(self.$t('common.tips.saveSuccess'))
        DocumentCategory.clearDocCategoryTypeTreeByLob()
        const currentData = {}
        currentData.uuid = result.data.uuid
        self.$emit('flush', currentData)
      }).finally(() => {
        self.fullscreenLoading.close()
      })
    },
    updateDocCategory() {
      const self = this
      this.fullscreenLoading = getLoading()
      updateDocCategory(this.docCategoryForm).then(() => {
        self.$message.success(self.$t('common.tips.editSuccess'))
        DocumentCategory.clearDocCategoryTypeTreeByLob()
        const currentData = {}
        currentData.uuid = self.docCategoryForm.uuid
        self.$emit('flush', currentData)
      }).finally(() => {
        self.fullscreenLoading.close()
      })
    },
    deleteDocCategory(uuid) {
      const self = this
      this.fullscreenLoading = getLoading()
      deleteDocCategory(uuid).then(() => {
        self.$message.success(self.$t('common.tips.deleteSuccess'))
        DocumentCategory.clearDocCategoryTypeTreeByLob()
        const currentData = {}
        currentData.parentUuid = self.currentData.parentUuid
        self.$emit('flush', currentData)
      }).finally(() => {
        self.fullscreenLoading.close()
      })
    },
    addDocType() {
      const self = this
      this.fullscreenLoading = getLoading()
      addDocType(this.docTypeForm).then((result) => {
        self.$message.success(self.$t('common.tips.saveSuccess'))
        DocumentCategory.clearDocCategoryTypeTreeByLob()
        const currentData = {}
        currentData.uuid = result.data.uuid
        self.$emit('flush', currentData)
      }).finally(() => {
        self.fullscreenLoading.close()
      })
    },
    updateDocType() {
      const self = this
      this.fullscreenLoading = getLoading()
      updateDocType(this.docTypeForm).then(() => {
        self.$message.success(self.$t('common.tips.editSuccess'))
        DocumentCategory.clearDocCategoryTypeTreeByLob()
        const currentData = {}
        currentData.uuid = self.docTypeForm.uuid
        self.$emit('flush', currentData)
      }).finally(() => {
        self.fullscreenLoading.close()
      })
    },
    deleteDocType(uuid) {
      const self = this
      this.fullscreenLoading = getLoading()
      checkDocType({ 'uuid': uuid }).then((res) => {
        if (res.data > 0) {
          self.$message.warning(self.$t('Message.AlreadyUsed'))
          return
        }
        this.doDeleteDocType(self, uuid)
      }).finally(() => {
        self.fullscreenLoading.close()
      })
    },
    doDeleteDocType(self, uuid) {
      deleteDocType(uuid).then(() => {
        self.$message.success(self.$t('common.tips.deleteSuccess'))
        DocumentCategory.clearDocCategoryTypeTreeByLob()
        const currentData = {}
        currentData.parentUuid = self.currentData.parentUuid
        self.$emit('flush', currentData)
      }).finally(() => {
        self.fullscreenLoading.close()
      })
    },
    setDefaultType() {
      const loading = getLoading4Cxt(this)
      DocumentCategory.getDocCategoryTypeTreeByLob({
        constructLobParent: false,
        lob: this.currentData.lob
      }).then(res => {
        const rowData = []
        for (const row of res.data) {
          let flag = false
          const pathArr = row.path.split(',')
          if (row.type === 1) {
            flag = pathArr.length === 1
          } else if (row.type === 2) {
            flag = pathArr.length > 1
          }
          if (flag) {
            if (row.code === this.currentData.defaultDocumentTypeCode) {
              row.checked = true
            } else {
              row.checked = false
            }
            rowData.push(row)
          }
        }
        this.docTypeTree.rowData = rowData
        this.docTypeTree.visible = true
      }).finally(() => {
        loading.close()
      })
    },
    saveDefaultType() {
      const docType = this.docTypeTree.rowData.find(p => p.type === 2 && p.checked)
      const loading = getLoading4Cxt(this.$refs.docTypeTreeDialog)
      setDefaultDocumentType({ lob: this.currentData.lob, defaultDocumentTypeKey: docType ? docType.uuid : '' }).then(res => {
        this.docTypeTree.visible = false
        DocumentCategory.clearDocCategoryTypeTreeByLob()
        this.$emit('flush', { uuid: this.currentData.uuid })
      }).finally(() => {
        loading.close()
      })
    },
    showFileTypeDialog() {
      this.fileTypeEditor.dataList = [...ExternalFileType.EXTERNAL_FILE_TYPES_XHQ, ...ExternalFileType.XHQ_DOC_CENTER_FILE, ...ExternalFileType.INVOICE_DOC_TYPE_FILE,
        ...ExternalFileType.RELEASE_BILL_GUARANTEE_FILE, ...ExternalFileType.MEIHUA_CUSTOMS]
      this.fileTypeEditor.fileCategory = this.docTypeForm.externalFileTypeList
      this.fileTypeEditor.visible = true
    },
    onSaveFileType(data) {
      this.docTypeForm.externalFileTypeList = data.documentTypeUuid
      this.showLabel(data.documentTypeUuid)
    },
    showLabel(value) {
      this.externalFileTypeList = ''
      if (value) {
        const pathObject = {}
        const pathArr = value.split(',')

        // 根据KEY 根据上级分组已经选择的文件类型
        for (const key of pathArr) {
          const data = ExternalFileType.getExternalFile(key)
          const label = this.$store.getters.language === 'zh' ? data.chineseName : data.englishName
          const upPath = data.path.split(',')[0]

          pathObject[upPath] = pathObject[upPath] ? pathObject[upPath] + ',' + label : label
        }
        // 根据分组好的数据，拼接成字符串
        this.externalFileTypeList = Object.keys(pathObject).map(key => {
          const upPath = ExternalFileType.getExternalFile(key)
          const label = this.$store.getters.language === 'zh' ? upPath.chineseName : upPath.englishName
          return label + ':' + pathObject[key]
        }).join(';')
      }
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(arr) {
      if (arr && arr.length > 0) {
        return arr.join(',')
      }
      return ''
    },
    setFileSyncRule() {
      this.fileSyncRuleDialog.visible = true
      this.fileSyncRuleDialog.form = { ...this.docTypeData }
      console.log('this.fileSyncRuleDialog.form', this.fileSyncRuleDialog.form)
      this.ctmSyncFileApprovedDocArray = this.strConvertToArray(this.fileSyncRuleDialog.form.ctmSyncFileApprovedDoc, true)
      this.etiSyncFileApprovedDocArray = this.strConvertToArray(this.fileSyncRuleDialog.form.etiSyncFileApprovedDoc, true)
    },
    onCrossTrustModelChange() {
      const form = this.fileSyncRuleDialog.form
      if (this.fileSyncRuleDialog.form.isCrossTrustMode) {
        form.isTrustToOperate = true
        form.isOperateToTrust = true
        form.trustSyncFileMode = 2
      } else {
        form.isTrustToOperate = false
        form.isOperateToTrust = false
        form.trustSyncFileMode = 0
        form.ctmSyncFileApprovedDoc = ''
        this.ctmSyncFileApprovedDocArray = []
      }
    },
    onExportToImportModelChange() {
      const form = this.fileSyncRuleDialog.form
      if (this.fileSyncRuleDialog.form.isExportToImportMode) {
        form.isExportToImport = true
        form.isImportToExport = true
        form.exportImportSyncFileMode = 2
      } else {
        form.isExportToImport = false
        form.isImportToExport = false
        form.exportImportSyncFileMode = 0
        form.etiSyncFileApprovedDoc = ''
        this.etiSyncFileApprovedDocArray = []
      }
    },
    saveFileSyncRule() {
      const loading = getLoading()
      this.fileSyncRuleDialog.form.ctmSyncFileApprovedDoc = this.arrayConvertToStr(this.ctmSyncFileApprovedDocArray)
      this.fileSyncRuleDialog.form.etiSyncFileApprovedDoc = this.arrayConvertToStr(this.etiSyncFileApprovedDocArray)
      updateDocType(this.fileSyncRuleDialog.form).then(() => {
        this.fileSyncRuleDialog.visible = false
        this.$message.success(this.$t('common.tips.editSuccess'))
        DocumentCategory.clearDocCategoryTypeTreeByLob()
        const currentData = {}
        currentData.uuid = this.docTypeForm.uuid
        this.$emit('flush', currentData)
      }).finally(() => {
        loading.close()
      })
    },
    // 将逗号分隔的字符串转换为数组
    strConvertToArray(str, isNumber = false) {
      if (str && str.length > 0) {
        const array = str.split(',')
        if (isNumber) {
          return array.map(Number)
        }
        return array
      }
      return []
    },
    // 将数组转换为逗号分隔的字符串
    arrayConvertToStr(arrys) {
      if (arrys && arrys.length > 0) {
        return arrys.join(',')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.doc-category{
  .template-rule-name-select{
    width: 110px !important;
  }
  /deep/ .el-radio__label {
    font-size: 12px;
    color: #000;
  }
}
</style>
